import { Box, Container } from "@mui/material";
import React from "react";
import { Trading } from "../../CommonPage/MarketFlow/Trading";
import GlobalAssets from "../../Componenets/Globalassets/GlobalAssets";
import WhyTradeForex from "../../CommonPage/WhyTradeForexs/WhyTradeForex";
import { PickPairs } from "../../CommonPage/PickPair/PickPairs";
import Wealth from "../../Componenets/Globalassets/Wealth";
import NewWealth from "../../Componenets/Globalassets/NewWealth";
import { NewCryptoPair } from "../../CommonPage/PickPair/NewCryptoPair";
import NewCommonity from "../../Componenets/Globalassets/NewCommonity";
import { PickPairCrypto } from "../../CommonPage/PickPair/PickPairCrypto";
import { NewPairIndices } from "../../CommonPage/PickPair/NewPairIndices";
import { useLanguage } from "../../context/LanguageContext";
import GlobalIndicc from "./GlobalIndicc";
import { PairIndic } from "../../CommonPage/PickPair/PairIndic";

export const EquityNew = () => {

  const { language, translations } = useLanguage();

  const cardData = [
    {
      heading:translations[language]?.indicesCardData?.title,
      logo: "/Images/energy1.png",
      description:translations[language]?.indicesCardData?.description,
    },
    {
      heading:translations[language]?.indicesCardData?.title1,
      logo: "/Images/energy2.png",
      description:translations[language]?.indicesCardData?.description1,
    },
    {
      heading:translations[language]?.indicesCardData?.title2,
      logo: "/Images/energy3.png",
      description:translations[language]?.indicesCardData?.description2,
    },
    {
      heading:translations[language]?.indicesCardData?.title3,
      logo: "/Images/energy4.png",
      description:translations[language]?.indicesCardData?.description3,

    },
  ];
  return (
    <Box>
      <Trading
      banner="https://res.cloudinary.com/dk24unkwu/image/upload/v1753695079/forexClean7_etioiy.png"
        titleLine1={translations[language]?.equityIndicesTrading?.titleLine1}
        titleLine2={translations[language]?.equityIndicesTrading?.titleLine2}
        active={translations[language]?.equityIndicesTrading?.active}
        subtitle={translations[language]?.equityIndicesTrading?.subtitle}
      />
      <GlobalIndicc />
      <WhyTradeForex
        subtitle={translations[language]?.whyTradeSub}
        title={translations[language]?.whyTradeindices}
        cardData={cardData}
      />
      <PairIndic
        title={translations[language]?.RegisBTNindices}
        subtitle={translations[language]?.RegisBTNiTitle}
      />
      <Container maxWidth="xl">
        <Box mt={10} mx={7}>
          <NewCommonity
            title={
              <>
               {translations[language]?.commonitEqu}<br/>{translations[language]?.commonit1}
              </>
            }
            subtitle={
              <>
               {translations[language]?.commonitEqu1}<br/>  {translations[language]?.commonitEqu2}
              </>
            }
          />
        </Box>
      </Container>
    </Box>
  );
};
